import type from "./types";

const initialState = {
  segmentSelectedElementsIds: []
}


export function saveLoadedSegmentId(state = initialState, action = {}) {
  switch (action.type) {
    case type.SEGMENT_LOADED_ELEMENTS:
      return {
        ...state,
        segmentSelectedElementsIds: [...state.segmentSelectedElementsIds, action.data]
      }
    case type.DELETE_SELECTED_SEGMENTID:
      return {
        ...state,
        segmentSelectedElementsIds: state.segmentSelectedElementsIds.filter(item => item !== action.data),
      }
    default:
      return state;
  }
}

